@if (contentBase64) {
  <tx-document-viewer
    width="100%"
    height="800px"
    [basePath]="url"
    dock="Window"
    [toolbarDocked]="true"
    [documentData]="contentBase64"
    [isSelectionActivated]="true"
    [showThumbnailPane]="true"
  ></tx-document-viewer>
}
